import Link from 'components/link/Link';
import RichText from 'components/rich-text/RichText';

import { IMapPopup } from 'source/NFR.types';

const MapPopup: React.FC<IMapPopup> = ({ address, link, title }) => (
  <div className="map-popup">
    {title && <h2>{title}</h2>}
    <div className="map-popup--text">
      <RichText {...address} />
    </div>

    <Link theme="underline" {...link} />
  </div>
);

MapPopup.displayName = 'MapPopup';

export default MapPopup;
